"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var apisauce_1 = require("apisauce");
var js_file_download_1 = __importDefault(require("js-file-download"));
var react_promise_tracker_1 = require("react-promise-tracker");
var notification_1 = __importDefault(require("./notification"));
var storage_1 = __importDefault(require("./storage"));
var createApi = function (_a) {
    var genericError = _a.genericError, throwError = _a.throwError, enabledPassError = _a.enabledPassError, mockConfig = _a.mockConfig, authConfig = _a.authConfig, disableNotification = _a.disableNotification, errorMessageTransform = _a.errorMessageTransform, apiConfig = __rest(_a, ["genericError", "throwError", "enabledPassError", "mockConfig", "authConfig", "disableNotification", "errorMessageTransform"]);
    var api = apisauce_1.create(apiConfig);
    if (authConfig) {
        api.addResponseTransform(function (response) {
            var originalError = response.originalError;
            if (originalError &&
                originalError.response &&
                (originalError.response.status === 401 || originalError.response.status === 403)) {
                window.location.replace(authConfig.unauthenticatedRedirectURL);
            }
        });
    }
    api.addRequestTransform(function (request) {
        request.headers['Accept-Language'] = storage_1.default.getLanguageIsoCode() || 'pt-BR';
    });
    if (!disableNotification) {
        api.addResponseTransform(function (response) {
            var data = response.data, config = response.config, originalError = response.originalError;
            var originalErrorMessage = originalError ? originalError.message : undefined;
            if (config && config.headers.Accept === 'application/json' && typeof data === 'string') {
                response.ok = false;
                originalErrorMessage = 'ui.message.api.error.invalidType';
            }
            if (!response.ok) {
                var errorMessage = data ? data.message : undefined;
                errorMessage = errorMessage || originalErrorMessage;
                errorMessage = errorMessage || 'ui.message.api.error.unexpected';
                var description = config ? "URL: " + config.url : 'ui.message.api.error.detail';
                if (errorMessageTransform) {
                    var customDescription = errorMessageTransform(response);
                    description = customDescription || description;
                }
                notification_1.default.error(description, errorMessage);
            }
        });
    }
    if (genericError) {
        api.addResponseTransform(function (response) {
            var data = response.data;
            if (!response.ok) {
                if (!data.error) {
                    genericError(true);
                    return null;
                }
            }
        });
    }
    if (mockConfig)
        mockConfig(api.axiosInstance);
    return {
        get: function (url, params, axiosConfig, loadArea) { return __awaiter(_this, void 0, void 0, function () {
            var _a, ok, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, react_promise_tracker_1.trackPromise(api.get(url, params, axiosConfig), loadArea)];
                    case 1:
                        _a = _b.sent(), ok = _a.ok, data = _a.data;
                        if (throwError) {
                            if (ok) {
                                return [2, data];
                            }
                            throw data;
                        }
                        if (enabledPassError) {
                            return [2, data];
                        }
                        return [2, ok ? data : undefined];
                }
            });
        }); },
        delete: function (url, params, axiosConfig, loadArea) { return __awaiter(_this, void 0, void 0, function () {
            var _a, ok, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, react_promise_tracker_1.trackPromise(api.delete(url, params, axiosConfig), loadArea)];
                    case 1:
                        _a = _b.sent(), ok = _a.ok, data = _a.data;
                        if (throwError) {
                            if (ok) {
                                return [2, data];
                            }
                            throw data;
                        }
                        if (enabledPassError) {
                            return [2, data];
                        }
                        return [2, ok ? data || true : undefined];
                }
            });
        }); },
        post: function (url, params, axiosConfig, loadArea) { return __awaiter(_this, void 0, void 0, function () {
            var _a, ok, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, react_promise_tracker_1.trackPromise(api.post(url, params, axiosConfig), loadArea)];
                    case 1:
                        _a = _b.sent(), ok = _a.ok, data = _a.data;
                        if (throwError) {
                            if (ok) {
                                return [2, data];
                            }
                            throw data;
                        }
                        if (enabledPassError) {
                            return [2, data];
                        }
                        return [2, ok ? data : undefined];
                }
            });
        }); },
        put: function (url, params, axiosConfig, loadArea) { return __awaiter(_this, void 0, void 0, function () {
            var _a, ok, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, react_promise_tracker_1.trackPromise(api.put(url, params, axiosConfig), loadArea)];
                    case 1:
                        _a = _b.sent(), ok = _a.ok, data = _a.data;
                        if (throwError) {
                            if (ok) {
                                return [2, data];
                            }
                            throw data;
                        }
                        if (enabledPassError) {
                            return [2, data];
                        }
                        return [2, ok ? data || true : undefined];
                }
            });
        }); },
        downloadFile: function (url, filename, params, axiosConfig, loadArea) { return __awaiter(_this, void 0, void 0, function () {
            var config, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = __assign({}, axiosConfig, { responseType: 'blob', headers: {
                                'Content-Type': 'application/json',
                            } });
                        return [4, react_promise_tracker_1.trackPromise(api.post(url, params, config), loadArea)];
                    case 1:
                        data = (_a.sent()).data;
                        if (data)
                            js_file_download_1.default(data, filename);
                        return [2];
                }
            });
        }); },
        getDownloadFile: function (url, filename, params, axiosConfig, loadArea) { return __awaiter(_this, void 0, void 0, function () {
            var config, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = __assign({}, axiosConfig, { responseType: 'blob', headers: {
                                'Content-Type': 'application/json',
                            } });
                        return [4, react_promise_tracker_1.trackPromise(api.get(url, params, config), loadArea)];
                    case 1:
                        data = (_a.sent()).data;
                        if (data)
                            js_file_download_1.default(data, filename);
                        return [2];
                }
            });
        }); },
        getNoLoad: function (url, params, axiosConfig) { return __awaiter(_this, void 0, void 0, function () {
            var _a, ok, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, api.get(url, params, axiosConfig)];
                    case 1:
                        _a = _b.sent(), ok = _a.ok, data = _a.data;
                        if (throwError) {
                            if (ok) {
                                return [2, data];
                            }
                            throw data;
                        }
                        if (enabledPassError) {
                            return [2, data];
                        }
                        return [2, ok ? data : undefined];
                }
            });
        }); },
        deleteNoLoad: function (url, params, axiosConfig) { return __awaiter(_this, void 0, void 0, function () {
            var _a, ok, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, api.delete(url, params, axiosConfig)];
                    case 1:
                        _a = _b.sent(), ok = _a.ok, data = _a.data;
                        if (throwError) {
                            if (ok) {
                                return [2, data];
                            }
                            throw data;
                        }
                        if (enabledPassError) {
                            return [2, data];
                        }
                        return [2, ok ? data || true : undefined];
                }
            });
        }); },
        postNoLoad: function (url, params, axiosConfig) { return __awaiter(_this, void 0, void 0, function () {
            var _a, ok, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, api.post(url, params, axiosConfig)];
                    case 1:
                        _a = _b.sent(), ok = _a.ok, data = _a.data;
                        if (throwError) {
                            if (ok) {
                                return [2, data];
                            }
                            throw data;
                        }
                        if (enabledPassError) {
                            return [2, data];
                        }
                        return [2, ok ? data : undefined];
                }
            });
        }); },
        putNoLoad: function (url, params, axiosConfig) { return __awaiter(_this, void 0, void 0, function () {
            var _a, ok, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, api.put(url, params, axiosConfig)];
                    case 1:
                        _a = _b.sent(), ok = _a.ok, data = _a.data;
                        if (throwError) {
                            if (ok) {
                                return [2, data];
                            }
                            throw data;
                        }
                        if (enabledPassError) {
                            return [2, data];
                        }
                        return [2, ok ? data || true : undefined];
                }
            });
        }); },
        addRequestTransform: api.addRequestTransform,
        addResponseTransform: api.addResponseTransform,
    };
};
exports.default = createApi;
